/**
 * @file: Peripheral.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 周边餐饮管理
 */
import request from '@/utils/request'

/**
 * 添加许周边商家信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopAdd(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/add',
    method: 'post',
    data
  })
}

/**
 * 删除周边商家信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopDelete(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/delete',
    method: 'post',
    data
  })
}

/**
 * 根据主键获取周边商家信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopGet(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/get',
    method: 'post',
    data
  })
}

/**
 * 根据商家名称获取周边商家列表信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopNameGet(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/name/get',
    method: 'post',
    data
  })
}

/**
 * 周边商家分页列表信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopPageGet(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/page/get',
    method: 'post',
    data
  })
}

/**
 * 统计各类别的商家数量(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopTypeCountGet(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/type/count/get',
    method: 'post',
    data
  })
}

/**
 * 根据商家类别获取周边商家信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopTypeGet(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/type/get',
    method: 'post',
    data
  })
}

/**
 * 根据主键修改周边商家信息(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function peripheralFoodShopUpdate(data) {
  return request({
    type: 'biz',
    url: 'peripheral/food/shop/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Peripheral.js